import { virgulaPonto } from '../../util/util';

// Preço por faixa (25/09): a faixa SEMPRE precifica o Pré-Evento; em Negociado, Fechamento e nas
// colunas negociadas adicionais ela só (re)aplica quando a etapa já tem preço (unitário ou
// % serviço > 0 — o operador preencheu ou copiou). Nunca preenche do zero, como o preço fixo de
// catálogo, que só vai para o Pré-Evento. Sem isso a linha nova nascia com Fechamento = 1 × preço
// e fazia a coluna Fechamento do orçamento inteiro contar como "preenchida" (última coluna
// preenchida no agregado, colunaVigentePolicy).
const positivo = (valor) => {
    const numero = virgulaPonto(valor);
    return Number.isFinite(numero) && numero > 0;
};

const etapaComPreco = (subitem = {}, campoValorUnitario, campoServico) => positivo(subitem?.[campoValorUnitario]) || positivo(subitem?.[campoServico]);

export function faixaAplicaNoMomento(subitem = {}, sufixoMomento = 'PreEvento') {
    if (sufixoMomento === 'PreEvento') return true;
    return etapaComPreco(subitem, `valorUnitario${sufixoMomento}`, `servico${sufixoMomento}`);
}

export function faixaAplicaNaColunaAdicional(subitem = {}, colunaId) {
    return etapaComPreco(subitem, `valorUnitarioNegociadoAdicional_${colunaId}`, `servicoNegociadoAdicional_${colunaId}`);
}
